import React from "react";
import PropTypes from "prop-types";
import PremierCountry from "../../components/PremierCountry/index.jsx";
import PremierButton from "./PremierButton/index.jsx";
import style from "./styles";

const changeCountryButton = React.createRef();

const CountrySelector = ({
  countryData,
  premierCountrySelector,
  updateCountry,
  assetsUrl,
}) =>
  countryData ? (
    <div className={style.PremierCountrySelector}>
      <PremierCountry assetsUrl={assetsUrl} countryData={countryData} />
      <PremierButton
        buttonText={premierCountrySelector.buttonText}
        onClick={() => updateCountry(changeCountryButton.current)}
        ref={changeCountryButton}
      />
    </div>
  ) : (
    <div>Loading</div>
  );

CountrySelector.propTypes = {
  countryData: PropTypes.object.isRequired,
  premierCountrySelector: PropTypes.object.isRequired,
  updateCountry: PropTypes.func.isRequired,
  assetsUrl: PropTypes.string,
};

export default CountrySelector;
